import styles from './logo.module.css';
import logo from '../../img/logo.svg?url';

export function Logo({text, className } : {
    text?: string 
    className?: string
}) {
    return <div className={`${styles.logo} ${className ?? ''}`}>
        <img src={ logo }/>
        { text ? <span>{ text }</span> : null }
    </div>
}